import React from "react";
import SbEditable from "storyblok-react";
import InputSizeMap from "./InputSizeMap";

const SelectInput = ({ blok, register, watch, errors }) => {

    let visibility = true;
    let watchField = "";
    let watchValue = "";

    if( blok.conditional_visibility ) {
        [watchField, watchValue] = blok.conditional_visibility?.split(": ");
        visibility = watch(watchField, watchValue);
    }

    return(
        <SbEditable content={blok}>
            <div className={`bg-white ${InputSizeMap(blok.size)} mb-4 ${visibility === true || visibility === watchValue ? "block" : "hidden"}`}>
                {!blok.hide_label && <label for={blok.name} className="block font-bold text-sm mb-1">{blok.label}{blok.required && <span className="text-teal">*</span>}</label>}
                <select {...register(blok.name, { required: blok.required })} className="py-3 px-4 block w-full placeholder-gray-300 text-sm rounded-md focus:ring-transparent focus:border-teal border-gray-200" name={blok.name} id={blok.name}>
                    {blok.options.replace(/(?:\r\n|\r|\n)/g, '').split(';').filter(option => option !== "").map((option, index) => {
                        const [value, label] = option.split(': ');
                        return <option key={index} value={value}>{label}</option>
                    })}
                </select>
                {errors[blok.name] && <span className="italic text-sm text-red-500">This field is required</span>}
            </div>
        </SbEditable>
    )
}

export default SelectInput